import { useActiveTiptapEditorCallback } from '../../../components/tiptapEditor/store/tiptapEditorStoreHooks';
import { useEffect } from 'react';

/**
 * On render get the current focused element and blur it.
 * On unmount refocus that editor.
 *
 * For use with sheets:
 * - Run this hook on the component that is rendered within the sheet (not the component with the sheet container).
 * - you MUST pass the onCloseTransitionStart={holdFocusWithoutKeyboard} prop to the sheet so that the focus is not lost during the transition.
 */
const usePauseEditorFocusWhileComponentRendered = (): void => {
    const focusEditor = useActiveTiptapEditorCallback((activeEditor) => {
        activeEditor?.commands.focus();
    }, []);

    useEffect(() => {
        const activeElement = document.activeElement as HTMLElement;
        activeElement?.blur();

        return () => {
            focusEditor();
        };
    }, []);
};

export default usePauseEditorFocusWhileComponentRendered;
